import { FC } from "react";

import { Button, Dialog, Stack, Typography, alpha } from "@mui/material";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useTranslation } from "hooks";
import { handleAmpliLoaded } from "helpers/handleAmpliLoaded";
import { ampli } from "services/ampli";

interface Props {
    onSubmit: () => void;
    onClose: () => void;
    error?: string;
}

export const PaymentErrorModal: FC<Props> = ({ onClose, onSubmit, error }) => {
    const { t } = useTranslation();
    if (!error) return null;

    const handleSubmit = () => {
        handleAmpliLoaded(() => ampli.subscriptionErrorTryAgainClicked());
        onSubmit();
    };

    return (
        <Dialog
            open={!!error}
            onClose={onClose}
            sx={(theme) => ({
                "& .MuiBackdrop-root": {
                    backgroundColor: alpha(theme.palette.background.secondary as string, 0.5),
                },
                "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: { xs: "100%", lmd: "520px" },
                    borderRadius: "24px",
                    padding: { xs: "24px 16px", lmd: "24px 41px" },
                    backgroundColor: "background.lightAccent",
                    margin: { xs: "15px", lmd: "32px" },
                },
            })}
        >
            <CloseOutlinedIcon
                sx={{
                    position: "absolute",
                    top: { xs: "16px", lmd: "24px" },
                    right: "11px",
                    cursor: "pointer",
                }}
                onClick={onClose}
            />
            <Stack alignItems="center" gap="45px">
                <img src="/icons/circle-error.svg" alt="declined transaction" style={{ width: "139px", height: "auto" }} />
                <Stack gap="4px">
                    <Typography variant="dmSansH4Semibold" textAlign="center" sx={{ fontSize: { xs: "28px", lmd: "34px" } }}>
                        {t(`checkout_errors.title.${error}`, { defaultValue: t("checkout_errors.title.other") })}
                    </Typography>
                    <Typography variant="dmSansBody1Regular" sx={{}} textAlign="center">
                        {t(`checkout_errors.subtitle.${error}`, { defaultValue: t("checkout_errors.subtitle.other") })}
                    </Typography>
                </Stack>
                <Button variant="themePrimary" sx={{ whiteSpace: "nowrap", maxWidth: "100%", mb: ".75rem", height: "60px" }} onClick={handleSubmit}>
                    <Typography
                        variant="dmSansH5Semibold"
                        sx={{
                            color: "inherit",
                            textTransform: "uppercase",
                        }}
                    >
                        {t(`checkout_errors.button_title.${error}`, { defaultValue: t("checkout_errors.button_title.other") })}
                    </Typography>
                </Button>
            </Stack>
        </Dialog>
    );
};
